import React, { useState, useEffect, useRef } from 'react';
import ReactMarkdown from 'react-markdown';

function TypeWriterEffect({ text, speed = 30 }) {
  const [displayedText, setDisplayedText] = useState('');
  const timeoutRef = useRef(null);

  useEffect(() => {
    // Reset when new text is received
    setDisplayedText('');
    let currentIndex = 0;

    const typeNextCharacter = () => {
      if (currentIndex < text.length) {
        setDisplayedText(text.slice(0, currentIndex + 1));
        currentIndex++;
        timeoutRef.current = setTimeout(typeNextCharacter, speed);
      }
    };

    timeoutRef.current = setTimeout(typeNextCharacter, speed);

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [text, speed]);

  return (
    <ReactMarkdown>
        {displayedText}
      </ReactMarkdown>
  );
}

export default TypeWriterEffect; 